<template>
    <div class="w-full flex h-full items-center justify-center mb-8 mt-4 sm:mb-8 sm:mt-4">
        <img src="../assets/images/logo.png" alt="logo" class="h-20 sm:h-20 px-4">
    </div>
</template>

<script>
    export default {
        name: 'Header',
    };
</script>

<style scoped>

</style>
